// extracted by mini-css-extract-plugin
export const base = "styles-module--base--fji-F";
export const icon = "styles-module--icon--GTBNp";
export const searchRoot = "styles-module--searchRoot--TxD8F";
export const search = "styles-module--search--aYdQw";